import Timer from 'tick-tock';

const components = {
  text: '#edit-box-text',
  input: '#edit-keywords',
};

export default class Search {
  constructor(element, customComponents) {
    // Make reference to the passed in element.
    this.element = element;

    // Manage intervals and timeouts with the TickTock tool.
    this.Timer = new Timer();

    // Merge default components with custom ones, if applicable.
    this.components = Object.assign({}, components, customComponents);

    // Reference the value of the searchText before we clear it out.
    this.searchText = this.text.value;

    // Clear out values of these components.
    this.input.value = '';
    this.text.value = '';

    // Event management
    this.listen();
  }

  // Focus the search box after a small delay.

  focusIn() {
    this.input.setAttribute('placeholder', '');
    this.Timer.setTimeout('focus', () => {
      this.typeOutPlaceholderText();
    }, 250);
  }

  // Cancel any search input timeouts that may be running.

  focusOut() {
    this.Timer.clear('focus');
    this.Timer.clear('typing');
  }

  // Types out placeholder text on focusin state.

  typeOutPlaceholderText() {
    let i = 0;
    if (!this.input.value.length) {
      this.Timer.setInterval('typing', () => {
        if (i <= this.searchText.length) {
          this.input.setAttribute('placeholder', this.searchText.substr(0, i));
          this.input.focus();
          i += 1;
        } else {
          this.Timer.clear('typing');
        }
      }, 60);
    }
  }

  // This is a workaround to overcome the default dd-search.js search
  // input scripted behaviors.

  resetSearchInput() {
    if (this.searchText === this.input.value) {
      this.input.value = '';
    }
  }

  // Listening so that we can override previously set scripted behaviors.

  listen() {
    this.input.addEventListener('focusin', this.resetSearchInput.bind(this));
    this.input.addEventListener('focusout', this.resetSearchInput.bind(this));
  }

  // Getters of various components.

  get text() {
    return this.element.querySelector(this.components.text);
  }

  get input() {
    return this.element.querySelector(this.components.input);
  }
}
